import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { uzLocale } from './translateDate';

const DatePickerComponent = ({ value, onChange, minDate, maxDate, sx, label = '', slotProps }) => {
  const { i18n } = useTranslation('translations');
  dayjs.locale(uzLocale, null, true);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      className="flex align-middle"
      adapterLocale={i18n.language === 'ru' ? 'ru' : 'uz'}
    >
      <DatePicker
        locale={i18n.language === 'ru' ? 'ru' : 'uz'}
        value={value}
        onChange={onChange}
        maxDate={maxDate}
        minDate={minDate}
        openTo="year"
        views={['year', 'month']}
        yearsOrder="desc"
        sx={sx || { minWidth: 250 }}
        label={label}
        slotProps={slotProps}
      />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
